import { TestStatusType } from '@Components/TestCard';
import { useGlobalization } from '@innovyze/stylovyze';
import { useMemo } from 'react';
import useSensorTroubleshoot from './useSensorTroubleshoot';

type SystemConnectionTestMessageReturn = string | null;

export type Messages = Partial<Record<TestStatusType | 'default', string>>;

export const useSystemConnectionTestMessage = (
	testStatusType: TestStatusType,
): SystemConnectionTestMessageReturn => {
	const { t } = useGlobalization();

	const messages = useMemo<Messages>(
		() => ({
			default: t('Test system connection'),
			pending: t('Attempting to test system connection..'),
			success: t('Connection established successfully'),
			error: t(
				'Connection attempt failed due to invalid credentials and/or invalid connection string',
			),
			timeout: t(
				'Connection attempt timed out. The edge device may be offline.',
			),
		}),
		[],
	);
	const message = useMemo(
		() => messages[testStatusType] || messages.default || null,
		[testStatusType],
	);

	return message;
};

export default useSensorTroubleshoot;
